/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {ConfigurationResponse, ServiceStatusResponse} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({providedIn: 'root'})
export class StatusService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * @summary Check Connection To Data Enclave
   */
  checkConnectionToDataEnclave<TData = boolean>(options?: HttpClientBodyOptions): Observable<TData>;
  checkConnectionToDataEnclave<TData = boolean>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  checkConnectionToDataEnclave<TData = boolean>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  checkConnectionToDataEnclave<TData = boolean>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/status`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/status`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/status`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Returns current backend configuration values relevant to the frontend.
   *
   * - `file_size_limit`: Max upload size (in bytes), or None if not set for any single file.
   * - `project_creation_admin_only`: Whether only admins can create projects.
   * - `irb_api_url_set`: Whether the IRB API server URL is configured.
   * - `allow_dataset_data_public`: Whether public datasets are allowed.
   * - `allow_hsd_data_download`: Whether HSD datasets can be downloaded.
   * - `allow_patient_derived_metadata`: Whether patient-derived (HIPAA-regulated) metadata is allowed.
   * - `allow_sensitive_metadata`: Whether sensitive data metadata is allowed.
   * - `allow_cui`: Whether CUI is allowed.
   * - `allow_file_uploads`: Whether file uploads are allowed.
   * @summary Get Configurations
   */
  getConfigurations<TData = ConfigurationResponse>(options?: HttpClientBodyOptions): Observable<TData>;
  getConfigurations<TData = ConfigurationResponse>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getConfigurations<TData = ConfigurationResponse>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getConfigurations<TData = ConfigurationResponse>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/status/configurations`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/status/configurations`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/status/configurations`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Returns true or false depending on if there is a connection to an online IRB service
   * @summary Get Irb Status
   */
  getIRBStatus<TData = boolean>(options?: HttpClientBodyOptions): Observable<TData>;
  getIRBStatus<TData = boolean>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getIRBStatus<TData = boolean>(options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getIRBStatus<TData = boolean>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/status/irb`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/status/irb`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/status/irb`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Server-sent event to check a user's live connection to the data enclave
   * @summary Check Live Connection To Data Enclave
   */
  checkLiveConnectionToDataEnclave<TData = void>(options?: HttpClientBodyOptions): Observable<TData>;
  checkLiveConnectionToDataEnclave<TData = void>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  checkLiveConnectionToDataEnclave<TData = void>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  checkLiveConnectionToDataEnclave<TData = void>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/status/live-connection`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/status/live-connection`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/status/live-connection`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * @summary Download Application Log
   */
  downloadApplicationLog<TData = unknown>(options?: HttpClientBodyOptions): Observable<TData>;
  downloadApplicationLog<TData = unknown>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  downloadApplicationLog<TData = unknown>(options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  downloadApplicationLog<TData = unknown>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/status/logs`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/status/logs`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/status/logs`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets status of 2 services - MinIO and Postgres
   * @summary Get Service Status
   */
  getServiceStatus<TData = ServiceStatusResponse>(options?: HttpClientBodyOptions): Observable<TData>;
  getServiceStatus<TData = ServiceStatusResponse>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getServiceStatus<TData = ServiceStatusResponse>(
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getServiceStatus<TData = ServiceStatusResponse>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/status/services`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/status/services`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/status/services`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
